import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeWhile } from 'rxjs';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { AuthService, UserService } from '../core/services';
import { KEYS } from '../core/constants';
import { PiopiyService } from '../core/services';

const passwordRegEx = new RegExp(
  '(?=.[a-z])(?=.[A-Z])(?=.[0-9])(?=.[$@$!%?&])[A-Za-zd$@$!%?&].{8,}'
);

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnDestroy, OnInit {
  loginForm!: FormGroup;
  private _alive: boolean = true;
  submitting: boolean = false;
  loginErrorMessage!: string;
  type: string = 'password';
  eyeOpen: boolean = false;
  tokenDecode: any = {};
  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UserService,
    private authService: AuthService,
    private _router: Router,
    private piopiyService : PiopiyService 
  ) {
    this.loginForm = this._formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]],
    });
  }
  ngOnInit(): void {
    if (localStorage.getItem(KEYS.TOKEN) && localStorage.getItem('role') == 'ADMIN') {
      this._router.navigate(['admin/dashboard'])
    }
  }
  onEyeClose() {
    this.type = 'text';
    this.eyeOpen = true;
  }

  onEyeOpen() {
    this.type = 'password';
    this.eyeOpen = false;
  }

  login() {
    this.submitting = true;
    this.authService.login(this.loginForm.value).pipe(takeWhile(() => this._alive))
      .subscribe({
        next: (res) => {
          // console.log('LoginComponent', this.authService.getCurrentUser());
          const user: any = this.authService.getCurrentUser();
          console.log(user.role);
          localStorage.setItem('role', user.role);
          localStorage.setItem('firstName',user.firstName);
          localStorage.setItem('lastName',user.lastName);
          localStorage.setItem('currentUserId',user.userId);
          // this.piopiyService.connect();
          this._router.navigate(['/admin/dashboard']);
        },
        error: () => {
          this.submitting = false;
          this.loginErrorMessage = 'Unable to log in with provided credentials';
        },
      });
  }

  ngOnDestroy(): void {
    this._alive = false;
  }
}
